import apiCall from "./apiCall";


export default {

    async analyseAnnualContraventionCollection()
    {
        return await apiCall("analysis/contraventions/annual", [])
    },


    async analyseLocationPerformance()
    {
        return await apiCall("analytics/location/performance/listing", [])
    }



}
